import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Video" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { usePageModal } from '@/hooks/usePageModal'
import { initEmptyParam } from '@/hooks/useInitParam'
import { ref } from 'vue'
import { getListData, getPageListData } from "@/service/main/system";

import { getGeneratUrl } from '@/service/main/fubo/generate'
import useClipboard from 'vue-clipboard3'
import { ElNotification } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'Video',
  setup(__props) {

initEmptyParam()

const getAllTeacher = async () => {
  const data = await getListData('/main/fuboTeacher/listAll', {})
  const searchTeacher = searchFormConfig.formItems.find(
    (item) => item.field === 'teacherId'
  )

  const modalTeacher = modalConfig.formItems.find(
    (item) => item.field === 'teacherId'
  )
  const options = data.map((item: any) => {
    return { title: item.name, value: item.id }
  })

  searchTeacher!.options = options

  modalTeacher!.options = options
}

getAllTeacher()

const getAllCourse = async () => {
  const data = await getListData('/main/fuboCourse/listAll', {})
  const searchCourse = searchFormConfig.formItems.find(
    (item) => item.field === 'courseId'
  )

  const modalCourse = modalConfig.formItems.find(
    (item) => item.field === 'courseId'
  )
  const options = data.map((item: any) => {
    return { title: item.name, value: item.id }
  })

  searchCourse!.options = options

  modalCourse!.options = options
}

getAllCourse()

const modalTitle = ref('新增')

const newCb = () => {
  modalTitle.value = '新增复播视频'
  defaultInfo.value.pcDisplay = true
}

const editCb = () => {
  modalTitle.value = '编辑复播视频'
}

const { toClipboard } = useClipboard()

const generate = async (id: string) => {
  const url = await getGeneratUrl(id)
  try {
    await toClipboard(url)
    ElNotification({
      title: '复制成功',
      message: '快去黏贴给客户吧',
      type: 'success'
    })
  } catch (e) {
    ElNotification({
      title: '复制失败',
      message: '请等一会，复制',
      type: 'error'
    })
  }
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

const handleQrCode = (row: any)=> {
  debugger
  const url = `/main/fuboGenerate/generate/qrcode/${row.id}`
  getPageListData(
    url,
    null,
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    debugger
    const down = document.createElement('a')
    down.download = `${row.title}.jpg`;
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}


return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "fuboVideo",
      deleteTip: "确认删除此视频吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData),
      onQrCodeClick: handleQrCode
    }, {
      cover: _withCtx((scope) => [
        _createVNode(_component_el_image, {
          style: {"width":"60px","height":"80px"},
          src: scope.row.cover,
          fit: "fill"
        }, null, 8, ["src"])
      ]),
      url: _withCtx((scope) => [
        _createVNode(_component_el_link, {
          href: scope.row.url,
          type: "primary",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode("查看链接")
          ]),
          _: 2
        }, 1032, ["href"])
      ]),
      generate: _withCtx((scope) => [
        _createVNode(_component_el_button, {
          size: "mini",
          type: "primary",
          onClick: ($event: any) => (generate(scope.row.id))
        }, {
          default: _withCtx(() => [
            _createTextVNode("点击复制")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "fuboVideo",
      validOtherInfo: () => true
    }, null, 8, ["defaultInfo", "modalConfig", "title"])
  ]))
}
}

})